import { render, staticRenderFns } from "./ContextMenuCloseOnClick.vue?vue&type=template&id=4adcef34&"
import script from "./ContextMenuCloseOnClick.vue?vue&type=script&lang=js&"
export * from "./ContextMenuCloseOnClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports